import { ReactNode } from 'react';

type SettingsContainerProps = {
    isLastItem?: boolean;
    children: ReactNode | ReactNode[];
};

function SettingsContainer({ isLastItem = false, children }: SettingsContainerProps): JSX.Element {
    return (
        <div
            className={`py-4 flex flex-col lg:grid lg:grid-cols-[350px_auto] gap-8 ${
                isLastItem ? '' : 'border-b border-gray-200 dark:border-white/[0.07]'
            }`}
        >
            {children}
        </div>
    );
}

export default SettingsContainer;
